'use strict';

module.exports = function twoDigits(value) {
		return value < 10 ? '0' + value : value;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-time-picker/lib/twoDigits.js
// module id = 361
// module chunks = 0